<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>จัดการบัญชี</strong></v-card-title>
          </v-layout>
          <!-- <v-layout row wrap justify-end>
            <v-flex xs5 sm2 md2 lg2>
              <v-btn class="mx-2 px-3" outlined color="indigo lighten-2" @click="openbankmodal('')">
                <v-icon>mdi-plus</v-icon>&nbsp;
                เพิ่มบัญชี
              </v-btn>
            </v-flex>
          </v-layout> -->
          <br />
        <v-layout justify-center>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start align-center>
              <v-flex xs12 sm6 md3 lg3 px-5>
                   <p style="color:#4C4C4C; font-size:90%;"><strong>{{bank_search.text}}</strong></p>
                    <v-combobox
                      v-model="bank_search.model"
                      :items="bank_search.items"
                      :item-text="bank_search.itemtext"
                      :item-value="bank_search.itemtext"
                      :return-object="false"
                      hide-selected
                      outlined
                      clearable
                      dense
                      multiple
                      persistent-hint
                      small-chips
                      v-on:input="bankfilterfunction()"
                      color="pink lighten-3"
                    ></v-combobox>
                </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อบัญชี</strong></p>
                <v-text-field v-model="bank_name_search" outlined clearable dense v-on:input="bankfilterfunction()" color="pink lighten-3"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>เลขที่บัญชี</strong></p>
                <v-text-field
                v-model="bank_no_search"
                outlined
                clearable
                dense
                v-on:input="bankfilterfunction()"
                color="pink lighten-3"
                :maxlength="13"
                v-mask="'###-#-#####-#'"
                ></v-text-field >
              </v-flex>
                <v-flex xs12 sm3 md3 lg3 px-3>
                  <v-layout align-end justify-end>
                    <div class="px-1">
                      <v-btn class="mx-2 px-3" outlined color="indigo lighten-2" @click="openbankmodal('')">
                        <v-icon>mdi-plus</v-icon>&nbsp;
                        เพิ่มบัญชี
                      </v-btn>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            <br />
          <v-data-table
            :headers="headers"
            :items="bankdata_view"
            :items-per-page="10"
            class="elevation-3"
            :loading="loading"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100]
            }"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="openbankmodal(item._id)">{{ item.bank }}</td>
                  <td @click="openbankmodal(item._id)">{{ item.bank_name }}</td>
                  <td @click="openbankmodal(item._id)">{{ item.bank_no_new }}</td>
                  <td>
                    <v-btn class="ma-2" outlined small fab color="pink lighten-2" @click="openbankmodal(item._id)">
                      <v-icon meduim>mdi-pencil</v-icon>
                    </v-btn>
                     <v-btn class="ma-2" outlined small fab color="red" @click="deletebank(item)">
                      <v-icon meduim>mdi-delete-forever</v-icon>
                    </v-btn>
                  </td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        <Bankmodal :parentgetdata="getdata" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Bankmodal from '@/components/Bankmodal'
import axios from 'axios'
import { sync } from 'vuex-pathify'
import swal from 'sweetalert'
export default {
  components: {
    Bankmodal
  },
  data: () => ({
    headers: [
      { text: 'ธนาคาร', align: 'center', sortable: false, value: 'bank' },
      { text: 'ชื่อบัญชี', align: 'center', sortable: false, value: 'bank_name' },
      { text: 'เลขที่บัญชี', align: 'center', sortable: false, value: 'bank_no' },
      { text: 'แก้ไข/ลบ', value: 'action', sortable: false, align: 'center' }
    ],
    bankdatas: [],
    bankdata_view: [],
    bank_search: { text: 'ธนาคาร', items: [], itemtext: 'bank', model: [] },
    bank_name_search: '',
    bank_no_search: '',
    loading: false
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin') {
        this.getdata()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    async getdata () {
      try {
        this.loading = true
        this.currentadmindata = ''
        let { data } = await axios.get(`${process.env.VUE_APP_API}/bank/get`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.bankdatas = data.map(bank => {
          return {
            ...bank,
            bank_no_new: `${bank.bank_no.slice(0, 3)}-${bank.bank_no.slice(3, 4)}-${bank.bank_no.slice(4, 9)}-${bank.bank_no.slice(9, 10)}`
          }
        })
        this.bankdata_view = this.bankdatas
        this.bank_search.items = this.bankdatas
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    openbankmodal (id) {
      this.bankmodal = true
      this.currentbankdata = id !== '' ? JSON.stringify(this.bankdatas.find(bank => bank._id === id)) : ''
    },
    async deletebank (bank) {
      try {
        await swal({
          title: `คุณแน่ใจที่จะลบบัญชี บัญชีเลขที่: ${bank.bank_no_new} ?`,
          icon: 'warning',
          buttons: ['ยกเลิก', 'ลบ'],
          dangerMode: true
        })
          .then(async (willDelete) => {
            if (willDelete) {
              let { data } = await axios.delete(`${process.env.VUE_APP_API}/bank/delete/${bank._id}`, {
                headers: {
                  Authorization: this.$cookies.get('token')
                }
              })
              if (data) {
                await swal(`บัญชีเลขที่: ${bank.bank_no_new} ถูกลบแล้ว!`, {
                  icon: 'success',
                  buttons: 'ตกลง'
                })
                this.getdata()
              }
            }
          })
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    bankfilterfunction () {
      this.bankdata_view = this.bankdatas.filter(bank => {
        let condition = [
          this.bank_name_search ? (bank.bank_name.toLowerCase()).includes((this.bank_name_search).toLowerCase()) : true,
          this.bank_no_search ? (bank.bank_no.toLowerCase()).includes((this.bank_no_search.replace(/-/g, '')).toLowerCase()) : true,
          this.bank_search.model.includes(bank.bank) || !this.bank_search.model.length
        ]
        return condition.every(con => con)
      })
    }
  },
  computed: {
    bankmodal: sync('bankmodal'),
    currentbankdata: sync('currentbankdata')
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}
.v-data-table {
  font-family: 'Kanit';
}
.v-text-field {
  font-family: 'Kanit';
}

.v-btn {
  font-family: 'Kanit';
  font-weight: bold;
}

td {
  max-width: 80px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}

</style>
